@if (showFooter) {
    <app-sprintpay-footer>
        <div class="d-flex footer flex-md-row flex-column mx-4 mt-3 mb-5 justify-content-md-between">
            <div
                class="d-flex flex-1 pe-1 footer-element-container mt-2 mt-md-0 justify-content-start justify-content-md-center"
            >
                <div class="flex-column justify-content-md-center">
                    <app-footer-title>Airports</app-footer-title>
                    @for (data of dataSource; let dataIndex = $index; track dataIndex) {
                        <app-footer-element
                            class="text-start"
                            type="text"
                            message="{{ data.airportName }} - {{ data.address1 }}"
                        ></app-footer-element>
                    }
                </div>
            </div>
            <div
                class="d-flex flex-1 px-0 footer-element-container mt-2 mt-md-0 justify-content-start justify-content-md-center"
            >
                <div class="flex-column justify-content-md-center">
                    <app-footer-title>Contact</app-footer-title>
                    <app-footer-element type="email" message="Email:" email="acscv2@wfs.aero"> </app-footer-element>
                    <app-footer-element type="text" message="Phone: (800) 353-1528"> </app-footer-element>
                </div>
            </div>
            <div
                class="d-flex flex-1 footer-element-container mt-2 mt-md-0 justify-content-start justify-content-md-center"
            >
                <div class="flex-column justify-content-md-center">
                    <app-footer-title>Support</app-footer-title>
                    <app-footer-element type="email" message="" email="support@cargosprint.com"> </app-footer-element>
                </div>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <app-footer-logo [width]="'168'" [height]="'23'" [customLogoName]="'logo-black'"></app-footer-logo>
    </app-sprintpay-footer>
}
